import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommandesService } from 'src/app/services/commandes/commandes.service';

@Component({
  selector: 'app-facture-trailer',
  templateUrl: './facture-trailer.component.html',
  styleUrls: ['./facture-trailer.component.css'],
})
export class FactureTrailerComponent implements OnInit {
  trailer: any = {};
  trailerId: string = '';

  constructor(
    private route: ActivatedRoute,
    private cmdsService: CommandesService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.trailerId = params.cmd;
      this.generateTrailer();
    });
  }

  generateTrailer() {
    this.cmdsService.generateTrailer(this.trailerId).then((result: any) => {
      console.log('generateTrailer :: ');
      console.log(result);
      if (result.response && result.data) {
        // this.isLoading = false;
        this.trailer = result.data;
      } else {
        alert(result.msg || 'Aucune remorque valide');
        location.href = '/all-trailers';
      }
    });
  }
}
